import classes from "../classes";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function ImportPicksBetList({ bets, currentTicketRaces, raceEntrants, races }) {

  var currentRaces = races.map((race) => {

    var raceId = race.get("id");

    var raceExistsOnCurrentTicket = typeof (currentTicketRaces.find(currentTicketRace => currentTicketRace.get("id") === raceId)) === "undefined";

    var primaryPick = (<div aria-label="Primary Pick" className="batch-c-19-24 batch-c-lg-5-12 import-table_label" />);
    var secondaryPick = (<div aria-label="Secondary Pick" className="batch-c-19-24 batch-c-lg-5-12 import-table_label" />);

    if (!bets.isEmpty() && !raceEntrants.isEmpty()) {
      var currentBet = bets.find(bet => bet.get("race_id") === raceId);

      if (typeof currentBet !== "undefined") {
        var primaryPickId = currentBet.get("race_entrant_id");
        var secondaryPickId = currentBet.get("alternate_pick_id");

        var primaryEntrant = raceEntrants.find(entrant => entrant.get("id") === primaryPickId);
        var secondaryEntrant = raceEntrants.find(entrant => entrant.get("id") === secondaryPickId);

        if (typeof primaryEntrant !== "undefined") {
          primaryPick = (
            <div aria-label="Primary Pick" className="batch-c-19-24 batch-c-lg-5-12 import-table_label">
              <span className="towel_icon towel_icon--small towel_icon--6" />

              <span className="text--is-bold">
                {primaryEntrant.get("horse_name")}
              </span>

              <span className="padding-left--is-5">
                {primaryEntrant.get("morning_line")}
              </span>
            </div>
          );
        }

        if (typeof secondaryEntrant !== "undefined") {
          secondaryPick = (
            <div aria-label="Secondary Pick" className="batch-c-19-24 batch-c-lg-5-12 import-table_label">
              <span className="towel_icon towel_icon--small towel_icon--6" />

              <span className="text--is-bold">
                {secondaryEntrant.get("horse_name")}
              </span>

              <span className="padding-left--is-5">
                {secondaryEntrant.get("morning_line")}
              </span>
            </div>
          );
        }
      }
    }

    var betInvalid = raceExistsOnCurrentTicket || race.get("status") !== "open";

    var raceRowClass = classes({
      "batch-g": true,
      "batch-g--padding": true,
      "batch-g--align-right": true,
      "border-bottom--width-1": true,
      "content--is-gray": betInvalid
    });

    return (
      <div className={raceRowClass} key={race.get("id")}>
        <div className="batch-c-5-24 batch-c-lg-1-6">
          {`${race.get("track_abbreviation")} - ${race.get("race_number")}`}
        </div>

        {primaryPick}

        {secondaryPick}
      </div>
    );
  });

  return (
    <div className="batch-c-1-1 batch-c-md-11-24">
      <div className="text-small margin-top--is-15 js-object-import-table-empty">
        <div className="batch-g batch-g--padding batch-g--align-right border-bottom--width-1 color--is-medium-gray">
          <div className="batch-c-5-24 batch-c-lg-1-6">
            Race
          </div>

          <div className="batch-c-19-24 batch-c-lg-5-12">
            <span className="visible--lg-min">
              Primary Pick
            </span>

            <span className="hidden--lg-min">
              Picks
            </span>
          </div>

          <div className="batch-c-19-24 batch-c-lg-5-12 visible--lg-min">
            Alternate Pick
          </div>
        </div>

        {currentRaces}
      </div>
    </div>
  );
});
